export default __webpack_public_path__ + "static/media/nibiruLogo.2a4e3654.svg";